import SessionInterfaceV1 from './SessionInterfaceV1';
import { SessionInterfaceV1Type } from '@clientos/types';

export { createNoopSessionInterfaceInterface } from './NoopInterface';

let sessionInterfaceV1: SessionInterfaceV1;

export function getSessionInterfaceV1(): SessionInterfaceV1Type {
  return sessionInterfaceV1.getInterface();
}

export default async function initializeSessionInterfaceV1(): Promise<SessionInterfaceV1Type> {
  if (sessionInterfaceV1) return sessionInterfaceV1.getInterface();
  sessionInterfaceV1 = new SessionInterfaceV1();

  return sessionInterfaceV1.getInterface();
}
